module.exports = __webpack_public_path__ + "static/c3-752a1415adb761954cce1fb6c4e3ba83.png";